import { render, staticRenderFns } from "./ProjectDisplay.vue?vue&type=template&id=9cffddd2&scoped=true&"
import script from "./ProjectDisplay.vue?vue&type=script&lang=js&"
export * from "./ProjectDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDisplay.vue?vue&type=style&index=0&id=9cffddd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cffddd2",
  null
  
)

component.options.__file = "www/vues/client/projectdisplay/ProjectDisplay.vue"
export default component.exports